export const RadioProps = {
	baseStyle: {
	  control: {
		transition: '0.2s ease-out',
		border: '1px',
		borderColor: 'solid.100',
		borderRadius: '50%', 
		_checked: {
		  bg: 'solid.900',
		  borderColor: 'solid.900',
		  _hover: {
			bg: 'solid.900',
			boxShadow: `
			  0px 0px 0px 1px #282E3A80,
			  0px 0px 0px 1px #FFFFFF,
			  0px 0px 0px 1px #282E3A,
			  0px 1px 1px 0px #282E3A80
			`,
			borderColor: 'white',
		  },
		},
		_hover: {
		  borderColor: 'solid.200',
		},
		_indeterminate: {
		  bg: 'solid.900',
		  boxShadow: '0px 0px 0px 1px #282E3A',
		  borderColor: 'solid.900',
		},
		_disabled: {
		  color: 'solid.100',
		  bg: 'solid.25',
		  borderColor: 'solid.50',
		},
	  },
	},
	variants: {
	  success: {
		control: {
		  _checked: {
			bg: 'success.100',
			borderColor: 'success.100',
			color: 'white',
			_hover: {
			  bg: 'success.100',
			  borderColor: 'success.100',
			  boxShadow: `
				0px 0px 0px 1px #00B67880,
				0px 0px 0px 1px #FFFFFF,
				0px 0px 0px 1px #00B678,
				0px 1px 1px 0px #00B67880
			  `,
			},
		  },
		 
		},
	  },
	  error: {
		control: {
		  _checked: {
			bg: 'error.50',
			borderColor: 'error.50',
			color: 'white',
			_hover: {
			  bg: 'error.50',
			  borderColor: 'error.50',
			  boxShadow: `
				0px 0px 0px 1px #FF000080,
				0px 0px 0px 1px #FFFFFF,
				0px 0px 0px 1px #FF0000,
				0px 1px 1px 0px #FF000080
			  `,
			},
		  },
		  
		},
	  },
	},
  }
  